import { TabBarStyles } from './types';

export const tabBarStyles: TabBarStyles = {
    labelStyle: { color: '#111111', fontWeight: 'bold', textTransform: 'capitalize' },
    indicatorStyle: { backgroundColor: '#0091EA' },
    style: { backgroundColor: '#ffffff' }
};
